export const NOTIFICATION_CATEGORIES = {
    TASK: { label: "Tugas", class: "bg-indigo-50 text-indigo-600" },
    KBM: { label: "KBM", class: "bg-cyan-50 text-cyan-600" },
    MONITORING: { label: "Perilaku", class: "bg-amber-50 text-amber-600" },
    KONSELING: { label: "Konseling", class: "bg-violet-50 text-violet-600" },
    RAPOR: { label: "Rapor", class: "bg-fuchsia-50 text-fuchsia-600" },
    TRYOUT: { label: "Tryout", class: "bg-sky-50 text-sky-600" },
    MUTABAAH: { label: "Mutabaah", class: "bg-teal-50 text-teal-600" },
    PRESTASI_LOMBA: { label: "Prestasi Lomba", class: "bg-amber-50 text-amber-600" },
    ACADEMY: { label: "Akademi", class: "bg-emerald-50 text-emerald-600" },
    GENERAL: { label: "Umum", class: "bg-slate-100 text-slate-600" },
};
